import Client from "./ApiClient";

const resource = "booking_slots";

const slotDetail = id => {
  return Client.get(`${resource}/${id}`);
};

const getAll = (psychologyId = "", page = 1, perPage = 10) => {
  return Client.get(
    `${resource}?psychologyId=${psychologyId ||
      ""}&page=${page}&perPage=${perPage}`
  );
};

const myPastBookingSlots = () => {
  return Client.get(`${resource}/psychology?past=true`);
};

const createNote = (slotId, data) => {
  return Client.post(`${resource}/${slotId}/notes`, data);
};

const updateNote = (slotId, noteId, data) => {
  return Client.put(`${resource}/${slotId}/notes/${noteId}`, data);
};

const deleteNote = (slotId, noteId) => {
  return Client.delete(`${resource}/${slotId}/notes/${noteId}`);
};

const addDocument = (slotId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return Client.post(`${resource}/${slotId}/documents`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const deleteDocument = (slotId, documentId) => {
  return Client.delete(`${resource}/${slotId}/documents/${documentId}`);
};

const adminCreate = (psychologyId, userId, startTime) => {
  return Client.post(`${resource}/admin-create`, {
    psychologyId,
    userId,
    startTime
  });
};

const adminCancel = slotId => {
  return Client.post(`${resource}/admin-cancel/${slotId}`);
};

export default {
  slotDetail,
  getAll,
  myPastBookingSlots,
  createNote,
  updateNote,
  deleteNote,
  addDocument,
  deleteDocument,
  adminCreate,
  adminCancel
};
